import { put, fork, call, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { hashHistory } from 'react-router'
import * as ACTION from '/redux/action'


export default function* () {

}


// WEBPACK FOOTER //
// ./src/redux/sagas/fetchsaga.js